import React, { useEffect, useState } from 'react';
import speakerIcon from '../../assets/icons/ic_speaker.svg'
import IconTint from 'react-icon-tint';
import { useAtom } from 'jotai';
import { savedAnnounced } from '../store/DataStore';
import ModalShell from './ModalShell';
import VoiceTextButton from './VoiceTextButton';

const AnnouncePopup = ({ isOpen, children, onClose, onSend }) => {
    const [show, setShow] = useState(isOpen);
    const [announceSaved, setAnnounceSaved] = useAtom(savedAnnounced)
    
    useEffect(() => {
        if (isOpen) {
            setShow(true);
        } else {
            setShow(false);
            setTimeout(onClose, 200);
        }
    }, [isOpen, onClose]);

    const handleClose = () => {
        setShow(false);
        setTimeout(onClose, 200);
    };

    const handleSend = () => {
        onSend();
        setShow(false);
        setTimeout(onClose, 200);
    }

    return (
        <ModalShell isMounted={show || isOpen} isOpen={show} onClose={handleClose} maxWidth="lg">
            <div className="-mt-2 flex flex-col items-center text-center">
                {children}
            </div>
            <div className="relative mt-5 w-full">
                <textarea
                    value={announceSaved}
                    onChange={(e) => setAnnounceSaved(e.target.value)}
                    placeholder="Type message here..."
                    className="h-44 w-full resize-none rounded-lg bg-[#DCE0FF] p-4 pr-14 font-heebo font-light outline-none"
                />
                <VoiceTextButton
                    value={announceSaved}
                    onChange={setAnnounceSaved}
                    ariaLabel="Dictate announcement message"
                    isActive={show && isOpen}
                    positionClassName="right-2 top-4"
                />
            </div>
            <div className="mt-5 flex justify-center">
                {announceSaved !== '' ? (
                    <button
                        type="button"
                        className="flex w-full items-center justify-center rounded-3xl bg-[#152FF5] px-5 py-2 text-white sm:w-auto"
                        onClick={handleSend}
                    >
                        <span className="font-heebo">Announce Message</span>
                        <IconTint src={speakerIcon} className="ml-2 h-5" color="#FFFFFF" />
                    </button>
                ) : (
                    <div className="flex w-full items-center justify-center rounded-3xl bg-[#152FF5] px-5 py-2 opacity-50 sm:w-auto">
                        <span className="font-heebo text-white">Announce Message</span>
                        <IconTint src={speakerIcon} className="ml-2 h-5" color="#FFFFFF" />
                    </div>
                )}
            </div>
        </ModalShell>
    );
};

export default AnnouncePopup;
